import { z } from "zod/v4";

// Branded ids: an EditionId can never be passed where a CampId is expected.
export const organizerIdSchema = z.uuid().brand<"OrganizerId">();
export const campIdSchema = z.uuid().brand<"CampId">();
export const editionIdSchema = z.uuid().brand<"EditionId">();
export const registrationIdSchema = z.uuid().brand<"RegistrationId">();
export const userIdSchema = z.uuid().brand<"UserId">();

export type OrganizerId = z.infer<typeof organizerIdSchema>;
export type CampId = z.infer<typeof campIdSchema>;
export type EditionId = z.infer<typeof editionIdSchema>;
export type RegistrationId = z.infer<typeof registrationIdSchema>;
export type UserId = z.infer<typeof userIdSchema>;

/** A calendar date, "YYYY-MM-DD" (the edition's own zone). */
export const localDateSchema = z.iso.date().brand<"LocalDate">();
export type LocalDate = z.infer<typeof localDateSchema>;

/** An RFC 3339 instant, UTC. */
export const instantSchema = z.iso.datetime({ offset: true });
